export const getTruncatedText = (
  inputString: string,
  maxLength = 20
): string => {
  let newString = inputString ?? "";

  if (newString.length > maxLength) {
    newString = newString.slice(0, maxLength).concat("...");
  }

  return newString;
};

export const getCapitalizedText = (inputString: string): string => {
  const stringArray = inputString.split(" ");
  const capitalizedArray = stringArray.map((word) => {
    if (!word) return "";
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });

  return capitalizedArray.join(" ");
};

// checks for:
// at least 1 string character,
// then an '@' character,
// followed by at least 1 string character,
// then a '.' character,
// followed by at least 1 string character
export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Allows Latin characters, numbers, and special characters in names to be shortened
// Ex: John S. instead of John Smith
export const isWesternText = (text?: string): boolean => {
  const nonWesternScriptRegex =
    /[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Hangul}\p{Script=Cyrillic}\p{Script=Arabic}\p{Script=Hebrew}\p{Script=Thai}\p{Script=Devanagari}]/u;
  return !nonWesternScriptRegex.test(text ?? "");
};

export const getYouTubeEmbedUrl = (url: string) => {
  const match = url.match(
    /(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
  );
  return match ? `https://www.youtube.com/embed/${match[1]}` : url;
};
